import './Dashboard.scss';

const Dashboard = ({ children, className = '' }) => (
  <div className={`Dashboard${className ? ` ${className}` : ''}`}>
    <div className="Dashboard__container">
      {children}
    </div>
  </div>
);

export default Dashboard;
